<template>
    <div class="card-body p-30" v-if="transactions.length>0">
        <div class="row">
            <div class="col-lg-4 col-xl-3">
                <!-- Nav tabs -->
                <div aria-orientation="vertical" class="nav flex-column nav-pills"
                     id="v-pills-tab"
                     role="tablist">
                    <template v-for="(transaction, index) in transactions">
                        <a :class="{'active transaction-active': activeTab === index+1}"
                           :href="'#item'+index+1"
                           :id="'#item'+index+1" @click="tab(index+1)"
                           aria-controls="v-pills-home"
                           aria-selected="true" class="nav-link" data-toggle="pill"
                           role="tab">{{transaction.name}}</a>
                    </template>
                </div>
            </div>
            <div class="col-lg-8 col-xl-9">
                <div class="tab-content" id="v-pills-tabContent">
                    <template v-for="(transaction, index) in transactions">
                        <div :class="{'show active': activeTab === index+1}"
                             :id="'#item'+index+1"
                             aria-labelledby="v-pills-home-tab" class="tab-pane fade"
                             role="tabpanel">
                            <div class="card-body">
                                <div class="card card-border">
                                    <div class="card-header">
                                        <h5 class="card-title mt-3">{{transaction.name}}</h5>
                                    </div>
                                    <div class="card-body" v-if="transaction.sources.length > 0">
                                        <b-table :busy="busy" :current-page="currentPage" :fields="fields"
                                                 :items="transaction.sources"
                                                 :sort-by="sortBy"
                                                 :per-page="perPage"
                                                 :sort-desc="sortDesc" :sort-direction="sortDirection" responsive
                                                 striped
                                                 tbody-tr-class="rowClass" v-if="transaction.sources.length > 0">
                                            <template #cell(context)="data">
                                                <div class="d-flex align-items-center">
                                                    <div>
                                                        <span class="btn-md btn-circle btn-outline-success"
                                                              v-if="data.value === 'trade'">
                                                            <i class="fas fa-handshake"></i>
                                                        </span>
                                                        <span class="btn-md btn-circle btn-outline-cyan"
                                                              v-if="data.value === 'purchase'">
                                                            <i class="fas fa-cart-arrow-down"></i>
                                                        </span>
                                                        <span class="btn-md btn-circle btn-outline-primary"
                                                              v-if="data.value === 'bill'">
                                                            <i class="fas fa-credit-card"></i>
                                                        </span>
                                                        <span class="btn-md btn-circle btn-outline-orange"
                                                              v-if="data.value === 'invoice'">
                                                            <i class="fas fa-money-bill-alt"></i>
                                                        </span>
                                                    </div>
                                                    <div class="">
                                                        <h6 class="m-b-0 font-16">{{data.value | capitalize}}</h6>
                                                    </div>
                                                </div>
                                            </template>
                                            <template #cell(created_at)="data">{{ data.value | date }}</template>
                                            <template #cell(number)="data">
                                                <router-link v-if="data.item.context==='purchase'" :to="{name: 'viewpo', params: {poid: data.item.id}}">
                                                    {{data.value}}
                                                </router-link>
                                                <router-link v-else-if="data.item.context==='bill'" :to="{name: 'view-marketplace-bill', params: {billid: data.item.id}}">
                                                    {{data.value}}
                                                </router-link>
                                            </template>
                                        </b-table>
                                    </div>
                                    <div class="card-body pb-5" v-else>
                                        <h4 class="card-title text-muted text-center">No records found</h4>
                                    </div>
                                    <div class="card-footer" v-if="totalRows>5">
                                      <div class="row">
                                        <div class="col">
                                          <per-page v-model="perPage" :total="totalRows"/>
                                        </div>
                                        <div class="col-auto" v-if="totalRows>perPage">
                                          <b-pagination :per-page="perPage" :total-rows="totalRows" v-model="currentPage"/>
                                        </div>
                                      </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
    <div class="card-body p-30" v-else>
        <h4 class="card-title text-muted text-center">No records found</h4>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import PerPage from "@/components/protected/common/PerPage.vue";

    export default {
        name: "TransactionTab",
        props: ['did'],
      components: {PerPage},
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        data() {
            return {
                activeTab: 1,
                transactions: [
                    {
                        name: 'Income',
                        sources: []
                    },
                    {
                        name: 'Expense',
                        sources: []
                    }
                ],
                fields: [
                    {
                        key: 'context',
                        label: 'Item',
                        sortable: true
                    },
                    {
                        key: 'number',
                        label: 'Number',
                        sortable: true
                    },
                    {
                        key: 'amount',
                        label: 'Amount',
                        sortable: true
                    },
                    {
                        key: 'created_at',
                        label: 'Created on',
                        sortable: true
                    }
                ],
                busy: false,
                currentPage: 1,
                perPage: 5,
                totalRows: 0,
                sortBy: 'name',
                sortDesc: false,
                sortDirection: 'asc',
            }
        },
        mounted() {
            this.init();
        },
        methods: {
            async init() {
                await Promise.all([
                    this.getPurchases(),
                    this.getBills()
                ]);
              this.totalRows = this.transactions[0].sources.length
            },
            async getPurchases() {
                try {
                    let {data} = await this.$http
                        .get(`/marketplaces/${this.currentOrg.marketplace_id}/purchases`, {
                            params: {
                                member_did: this.did
                            }
                        });
                    this.transactions[0].sources = data.purchases.map(p => ({
                        id: p.id,
                        context: 'purchase',
                        number: p.po_number,
                        amount: p.total.currency_symbol + ' ' + p.total.amount,
                        created_at: p.created_at

                    }));
                } catch (e) {

                }
            },
            async getBills() {
                try {
                    let {data} = await this.$http
                        .get(`/marketplaces/${this.currentOrg.marketplace_id}/bills`, {
                            params: {
                                member_did: this.did
                            }
                        });
                    this.transactions[1].sources = data.bills.map(bill => ({
                        id: bill.id,
                        context: 'bill',
                        number: bill.bill_number,
                        amount: bill.total.currency_symbol + ' ' + bill.total.amount,
                        created_at: bill.created_at

                    }));
                } catch (e) {

                }
            },
            tab(tabname) {
                this.activeTab = tabname;
                if(tabname === 2){
                  this.totalRows = this.transactions[1].sources.length
                }else if(tabname === 1){
                  this.totalRows = this.transactions[0].sources.length
                }
            },
        }
    }
</script>

<style scoped>
    .card-border {
        background-clip: border-box;
        border: 1px solid rgba(0, 0, 0, 0.125);
        border-radius: 0.25rem;
    }
</style>
